module.exports = __webpack_public_path__ + "img/icon-daijia.bfd015a7.png";